/*
 * Infinite Age — Sea Moss Advanced (Chondrus Crispus) Halloween lander.
 * Vanilla JS port of the live page's theme scripts (jQuery + slick removed).
 */
(function () {
  'use strict';

  var header = document.querySelector('.top_fix_bar');
  var callBtn = document.getElementById('call-btn');
  var stickyAnchor = document.querySelector('.sticky_btn_show');
  var footer = document.querySelector('.footer');
  var HEADER_H = 72;

  /* ---------- Footer year ---------- */
  document.querySelectorAll('.js-year').forEach(function (el) {
    el.textContent = new Date().getFullYear();
  });

  /* ---------- Anchor links: smooth scroll under the fixed header ---------- */
  function scrollToTarget(target) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_H;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href');
    if (id.length < 2) return;
    var target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    scrollToTarget(target);
  });

  /* ---------- Sticky header + bottom "Buy" bar (same rules as live) ---------- */
  function inView(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.top <= window.innerHeight && r.bottom >= 0;
  }
  function onScroll() {
    var y = window.pageYOffset;
    if (header) header.classList.toggle('fixed_nav', y > 110);

    if (!callBtn || !stickyAnchor) return;
    var anchorTop = stickyAnchor.getBoundingClientRect().top + y + 100;
    callBtn.style.display = y > anchorTop ? '' : 'none';

    var footerTop = footer ? footer.getBoundingClientRect().top + y : Infinity;
    var viewBottom = y + window.innerHeight;
    if (footerTop >= viewBottom + 20 || footerTop + callBtn.offsetHeight >= viewBottom + 104) {
      var overBuyBox = inView(document.querySelector('.choose_package1')) ||
        inView(document.querySelector('.choose_package2')) ||
        inView(document.querySelector('.section8'));
      callBtn.style.position = overBuyBox ? 'relative' : 'fixed';
    } else {
      callBtn.style.position = 'relative';
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- FAQ accordion: one open at a time, 500ms slide ---------- */
  function slide(el, open) {
    if (open) {
      el.style.display = 'block';
      var h = el.scrollHeight;
      el.style.height = '0px';
      requestAnimationFrame(function () { el.style.height = h + 'px'; });
    } else {
      el.style.height = el.scrollHeight + 'px';
      requestAnimationFrame(function () { el.style.height = '0px'; });
    }
    el.addEventListener('transitionend', function done() {
      el.removeEventListener('transitionend', done);
      el.style.height = '';
      if (!open) el.style.display = 'none';
    });
  }
  document.querySelectorAll('.sec1_4questions_head').forEach(function (head) {
    var answer = head.nextElementSibling;
    head.setAttribute('role', 'button');
    head.setAttribute('tabindex', '0');
    head.setAttribute('aria-expanded', 'false');
    function toggle() {
      var isOpen = head.classList.contains('sec1_4questions_head_open');
      var box = head.closest('.sec1_4questions_box');
      box.querySelectorAll('.sec1_4questions_head_open').forEach(function (other) {
        if (other === head) return;
        other.classList.remove('sec1_4questions_head_open');
        other.setAttribute('aria-expanded', 'false');
        slide(other.nextElementSibling, false);
      });
      head.classList.toggle('sec1_4questions_head_open', !isOpen);
      head.setAttribute('aria-expanded', String(!isOpen));
      slide(answer, !isOpen);
    }
    head.addEventListener('click', toggle);
    head.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  });

  /* ---------- Buy box gallery (replaces slick main + thumbs) ---------- */
  document.querySelectorAll('.purchase_block_left').forEach(function (block) {
    var track = block.querySelector('.purchase_product_slider');
    var thumbs = block.querySelectorAll('.pur_thumb_slider_inner');
    if (!track) return;
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      });
    });
  });

  /* ---------- Add to cart: lock the button so it can't be double-submitted ---------- */
  document.addEventListener('submit', function (e) {
    var btn = e.target.querySelector('button[type="submit"]');
    if (!btn) return;
    btn.disabled = true;
    btn.style.opacity = '0.6';
    btn.style.cursor = 'not-allowed';
  });
  // Re-enable buttons when the visitor comes back with the browser Back button
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('form button[type="submit"]').forEach(function (btn) {
      btn.disabled = false;
      btn.style.opacity = '';
      btn.style.cursor = '';
    });
  });

  /* ---------- Results timeline (same logic as live) ---------- */
  var steps = Array.prototype.slice.call(document.querySelectorAll('.timeline__row_center_step'));
  var boxes = document.querySelectorAll('.timeline__row_content_box');
  var section = document.querySelector('.timeline__mid');
  var entry = document.querySelector('.timeline__mid_row');
  if (steps.length && section && entry) {
    var total = 0;
    var stepDist = [];
    var ticking = false;
    var centre = function (el) {
      var r = el.getBoundingClientRect();
      return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    };
    var dist = function (a, b) {
      var p = centre(a), q = centre(b);
      return Math.sqrt(Math.pow(q.x - p.x, 2) + Math.pow(q.y - p.y, 2));
    };
    var setHeight = function () {
      total = dist(steps[0], steps[steps.length - 1]);
      entry.style.setProperty('--timeline-height', total + 'px');
      stepDist = steps.map(function (s) { return dist(steps[0], s); });
    };
    var update = function () {
      ticking = false;
      var r = section.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var fromMid = r.top - window.innerHeight * 0.85;
      var h, all;
      if (fromMid > 0) { h = 0; all = false; }
      else if (fromMid <= -r.height) { h = total; all = true; }
      else { h = Math.min(Math.abs(fromMid) / r.height, 1) * total; all = null; }
      entry.style.setProperty('--timeline-height-dynamic', h + 'px');
      steps.forEach(function (step, i) {
        var on = all !== null ? all : h >= stepDist[i];
        step.classList.toggle('viewing', on);
        if (boxes[i]) boxes[i].classList.toggle('viewing', on);
      });
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setHeight, 250);
    });
    setHeight();
    update();
  }
})();

/* Stamped reviews widget (same keys as live) */
function myInit() {
  if (window.StampedFn) StampedFn.init({ apiKey: 'pubkey-583gze5eePwY6to1l2W4wF19FK6tkq', sId: '112806' });
}
